import React from 'react';
import Navbar from '../components/Navbar'
import RetroPong from '../components/game/Pong.jsx';
import powederImage from '../../src/assets/powered in b2r6nnies.png'
import '../styles/Hero.css';

  
  export default function ArcadePage() {

   return (
     <div className="desktop-layout">
       <Navbar></Navbar>
       <div style={{position: 'relative', display : 'flex', flexDirection:'column', marginTop: '5%'}}>
          <RetroPong></RetroPong>
       </div>
     
       <footer>
          <div className="logo-container">
            <img src={powederImage} alt="Powdered in Baronnies" className="logo" />
          </div>
       </footer>
      </div>
   );
}
